<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg4 pr-6 pl-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Từ ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg4 pr-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedEndDateFormatted"
                    label="Đến ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg4 pr-6>
            <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
        </v-flex>
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table 
                    fixed-header 
                    height="70vh" 
                    :headers="headers"
                    :items="items" 
                    :server-items-length="items ? items.length : 0" 
                    :loading="loading" 
                    :mobile-breakpoint="100"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:item="{ item, index }">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.ID }}</td>
                            <td>{{ item.BoughtDate | display_date }}</td>
                            <td>{{ item.BuyerName }}</td>
                            <td class="text-end">{{ item.TotalRealAmountCNY | currency('¥', 2) }}</td>
                            <td class="text-end">{{ item.ExchangeRate | currency('', 0) }}</td>
                            <td class="text-end">{{ item.ExchangeRevenue | currency('', 2) }}</td>
                            <td class="text-end">{{ item.Revenue | currency }}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="grey lighten-3 font-weight-bold">
                            <td colspan="4" class="text-center">TỔNG CỘNG</td>
                            <td class="text-end">{{ getSummary('TotalAmount') | currency('¥', 2) }}</td>
                            <td colspan="2"></td>
                            <td class="text-end">{{ getSummary('TotalRevenue') | currency }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            viewName: "thong-ke-tien-te",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            headers: [
                {
                    text: 'STT',
                    sortable: false,
                    width: '60px'
                },
                {
                    text: 'Mã đơn hàng',
                    value: 'OrderID',
                    sortable: true
                },
                {
                    text: 'Ngày mua',
                    value: 'BoughtDate',
                    sortable: true
                },
                {
                    text: 'Nhân viên',
                    value: 'BuyerName',
                    sortable: true
                },
                {
                    text: 'Số tiền hàng (¥)',
                    value: 'TotalRealAmountCNY',
                    align: 'end',
                    sortable: true
                },
                {
                    text: 'Tỷ giá (₫/¥)',
                    value: 'ExchangeRate',
                    align: 'end',
                    sortable: true
                },
                {
                    text: 'Chênh TG (₫/¥)',
                    value: 'ExchangeRevenue',
                    align: 'end',
                    sortable: true
                },
                {
                    text: 'Lãi tỷ giá (₫)',
                    value: 'Revenue',
                    align: 'end',
                    sortable: true
                }
            ]
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.orderMoney.data,
            summary: state => state.report.orderMoney.summary,
            loading: state => state.report.loading,
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                sortBy: 'BoughtDate'
            };
            this.$store.dispatch("report/getOrderMoney", param);
        },
        getSummary(key) {
            const item = _.find(this.summary, {
                index: key
            });
            return item ? item.Total : 0;
        },
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>